import I18n from 'I18n';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { AutomationPlatformFlowProperties } from 'automation-ui-management/constants/CrmWorkflowProperties';
const getFlowDisplayName = crmObject => {
  const name = getPropertyValue(crmObject, AutomationPlatformFlowProperties.NAME);
  if (!name) {
    return I18n.text('automation-ui-index.table.body.rows.noWorkflowName');
  }
  return name;
};
export default getFlowDisplayName;